module.exports = {
    API_URL: 'https://life.transcode.co.th/api/',
    API_URL_STAG: 'https://life-easy.transcode.co.th/api/',
    API_URL2: 'http://localhost:8080/'
}

